import React from 'react'
import { Link } from 'react-router-dom'

import OAuthSignInButtons from '../ui/button/oauthSignIn/OAuthSignInButtons'
import TinyInvoiceLogo from '../ui/logo'

import './styles.scss'

export type AuthFormProps = {
  title: string
  onGoogleSignIn?: () => void
  onMicrosoftSignIn?: () => void
  /** When set (e.g. inside a modal), called instead of navigating to `/`. */
  onBackClick?: () => void
  className?: string
}

const AuthForm = ({
  title,
  onGoogleSignIn,
  onMicrosoftSignIn,
  onBackClick,
  className,
}: AuthFormProps) => {
  const panelClassName = ['auth-form', 'bg-white', className].filter(Boolean).join(' ')

  const backLink = onBackClick ? (
    <button type='button' className='auth-form__back' onClick={onBackClick}>
      ← Back to home
    </button>
  ) : (
    <Link to='/' className='auth-form__back'>← Back to home</Link>
  )

  return (
    <div className={panelClassName}>
      <div className='auth-form__brand'>
        <TinyInvoiceLogo width={180} />
      </div>
      <p className='pt-2 pb-4 auth-form__title'>{title}</p>
      <OAuthSignInButtons onGoogleSignIn={onGoogleSignIn} onMicrosoftSignIn={onMicrosoftSignIn} />
      <p className='pb-4' />
      {backLink}
    </div>
  )
}

export default AuthForm
